
import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { CollectionsProvider } from '@/contexts/CollectionsContext';
import { OperationsMonitor } from '../operations/OperationsMonitor';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <CollectionsProvider>
      <div className="flex flex-col min-h-screen">
        <Sidebar />
        <Header />
        <div className="flex-grow ml-64 mt-16 p-6">
          {children}
          <OperationsMonitor />
        </div>
      </div>
    </CollectionsProvider>
  );
}
